const ZEROBOUNCE_KEY = process.env.REACT_APP_ZEROBOUNCE_API_KEY;

export async function verifyEmail(email) {
  if (!email || !email.trim() || !ZEROBOUNCE_KEY) return null;
  try {
    const resp = await fetch(
      `https://api.zerobounce.net/v2/validate?api_key=${ZEROBOUNCE_KEY}&email=${encodeURIComponent(email.trim())}`
    );
    if (!resp.ok) return null;
    const data = await resp.json();
    return data.status || null;
  } catch (e) {
    console.warn("ZeroBounce verify failed:", e);
    return null;
  }
}

// Verify all emails on a contact object and attach status fields
export async function autoVerifyContact(contact) {
  const updates = {};
  if (contact.email1 && !contact.email1_status) {
    const status = await verifyEmail(contact.email1);
    if (status) updates.email1_status = status;
  }
  if (contact.email2 && !contact.email2_status) {
    const status = await verifyEmail(contact.email2);
    if (status) updates.email2_status = status;
  }
  if (contact.email3 && !contact.email3_status) {
    const status = await verifyEmail(contact.email3);
    if (status) updates.email3_status = status;
  }
  return { ...contact, ...updates };
}
